import { render } from "./Footer.vue?vue&type=template&id=f9a51064&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=f9a51064&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f9a51064"

export default script